import { configureStore, createListenerMiddleware, } from '@reduxjs/toolkit';
import { LSHelper } from '@/libs/localStorage';
import { isIframe } from '@/libs/helpers';
import rootReducers from './models/rootReducers';
import { getPersistedState } from './persistedState';
import { LOCALSTORAGE_MODELS } from './libs/constants';
import { FORMS_STATE_NAMESPACE } from './models/forms';
import { FLIGHTS_STATE_NAMESPACE } from './models/flights';
export const REQUEST_STATE_NAMESPACE = 'request';
const preloadedState = getPersistedState();
const localeStorageMiddleware = createListenerMiddleware();
const localeStorageStart = localeStorageMiddleware.startListening;
const persistedStates = [FORMS_STATE_NAMESPACE, FLIGHTS_STATE_NAMESPACE];
localeStorageStart({
    predicate: (action) => {
        if (isIframe()) {
            return false;
        }
        if (persistedStates.some((stateNamespace) => action.type?.startsWith(stateNamespace)))
            return true;
        return false;
    },
    effect: (_action, listenerApi) => {
        const state = listenerApi.getState();
        const statesToStorage = {};
        LOCALSTORAGE_MODELS.forEach((stateNamespace) => {
            statesToStorage[stateNamespace] = state[stateNamespace];
        });
        LSHelper.set(statesToStorage);
    },
});
function configureAppStore() {
    const store = configureStore({
        reducer: rootReducers,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(localeStorageMiddleware.middleware),
        devTools: __ENV__ !== 'production',
        enhancers: [],
    });
    if (__ENV__ !== 'production' && module.hot) {
        module.hot.accept('./models/rootReducers.ts', () => store.replaceReducer(rootReducers));
    }
    return store;
}
const store = configureAppStore();
export const appState = store;
